module.exports = __webpack_public_path__ + "static/media/esp-flag.e1ba650d.png";